const PhoneState = () =>
  import('@/views/main/wechatMgmt/phoneState/PhoneState.vue')
export default {
  path: '/main/wechatMgmt/phoneState',
  name: 'PhoneState',
  component: PhoneState
}
